import { render } from "./I18nTitles.vue?vue&type=template&id=4d6347b0"
import script from "./I18nTitles.vue?vue&type=script&lang=js"
export * from "./I18nTitles.vue?vue&type=script&lang=js"

import "./I18nTitles.vue?vue&type=style&index=0&id=4d6347b0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/I18nTitles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d6347b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d6347b0', __exports__)) {
    api.reload('4d6347b0', __exports__)
  }
  
  module.hot.accept("./I18nTitles.vue?vue&type=template&id=4d6347b0", () => {
    api.rerender('4d6347b0', render)
  })

}


export default __exports__